import React from "react";
import { DialogActions, Button } from "@material-ui/core";

import { Typography } from "material-ui";
import { Dialog } from "material-ui";
import { DialogTitle } from "material-ui";
import { DialogContent } from "material-ui";
import { DialogContentText } from "material-ui";
import { enums } from "../../../enums/index";
import { getUserMeasureSystem } from "../../../utils/user/info";
import { convertCo2GramsByKmToBestUnit, convertKilometersInUserUnit, convertCO2GramsToBestUnit } from "../../../utils/unitHelper";

export class AvoidedCO2Dialog extends React.Component {

  render() {
    const { t, isOpen, toggle, co2Equivalents, user } = this.props;

    let unitSystem = getUserMeasureSystem(user)

    let CO2Equivalent_co2_for_1km_driven_in_g=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.CO2_FOR_1KM_DRIVEN_IN_G);
    let CO2Equivalent_co2_for_1km_travelled_in_g=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.CO2_FOR_1KM_TRAVALLED_IN_G);
    let CO2Equivalent_world_tour_distance_in_km=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.WORLD_TOUR_DISTANCE_IN_KM);
    let CO2Equivalent_average_household_electricity_consumption_in_kwh=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.AVERAGE_HOUSEHOLD_ELECTRICITY_CONSUMPTION_IN_KWH);
    let CO2Equivalent_nuclear_waste_for_1mwh_nuclear_electricity_in_g=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.NUCLEAR_WASTE_FOR_1MWH_NUCLEAR_ELECTRICITY_IN_G);
    let CO2Equivalent_co2_per_tree_seedings_in_t=co2Equivalents.find(CO2Equivalent => CO2Equivalent.co2EquivalentName === enums.CO2Equivalents.CO2_PER_TREE_SEEDING_IN_T);

    let [co2DistanceDrivenEquivalentValue, co2DistanceDrivenEquivalentUnit] = convertCo2GramsByKmToBestUnit(CO2Equivalent_co2_for_1km_driven_in_g.co2EquivalentValue, user)
    let distanceConversionText = t(`With the avoided CO2, the driven distance is calculated using`);
    distanceConversionText += ` ${co2DistanceDrivenEquivalentValue} ${co2DistanceDrivenEquivalentUnit} `;
    distanceConversionText += t( `which is the average given the geographical location of the current organization.`);

    let [co2DistanceWorldTourEquivalentValue, co2DistanceWorldTourEquivalentUnit] = convertCo2GramsByKmToBestUnit(CO2Equivalent_co2_for_1km_travelled_in_g.co2EquivalentValue, user)
    let worldTourConversionText = t( `With the avoided CO2, the plane distance is calculated using` )
    worldTourConversionText += ` ${co2DistanceWorldTourEquivalentValue } ${co2DistanceWorldTourEquivalentUnit } `
    worldTourConversionText += t( `and a distance of` )

    let [worldTourDistanceValue, worldTourDistanceUnit] = convertKilometersInUserUnit(CO2Equivalent_world_tour_distance_in_km.co2EquivalentValue, user)
    worldTourConversionText += ` ${worldTourDistanceValue } ${worldTourDistanceUnit} `
    worldTourConversionText += t( `for a world tour.` )

    let co2RetrievalText = t( "For each day, we retrieve the average CO2 emissions for that day")
    let co2RetrievalUnit = unitSystem === 'imperial' ? t("lbs of CO2/MWh") : t("g of CO2/kWh")
    co2RetrievalText += ` (${co2RetrievalUnit}).`
    
    let [nuclearWasteValue, nuclearWasteUnit]= convertCO2GramsToBestUnit(CO2Equivalent_nuclear_waste_for_1mwh_nuclear_electricity_in_g.co2EquivalentValue, t, user)
    let nuclearWasteText = t( `The production of 1 MWh of nuclear electricity produces about` )
    nuclearWasteText += ` ${nuclearWasteValue} ${nuclearWasteUnit} ` ;
    nuclearWasteText += t(`of radioactive waste.`)

    let co2PerTreeSeedingsInGrams = CO2Equivalent_co2_per_tree_seedings_in_t.co2EquivalentValue * 10**6
    let [avoidedCo2PerTreeSeedingsValue, avoidedCo2PerTreeSeedingsUnit]= convertCO2GramsToBestUnit(co2PerTreeSeedingsInGrams, t, user)

    let avoidedCo2PerTreeSeedingsText = t("Number of urban tree seedlings grown for 10 years, having one urban tree planted for")
    avoidedCo2PerTreeSeedingsText += ` ${avoidedCo2PerTreeSeedingsValue} ${avoidedCo2PerTreeSeedingsUnit} `;
    avoidedCo2PerTreeSeedingsText += `${t("of CO2 avoided")}.`


    return (
      <Dialog
        fullScreen={false}
        open={isOpen}
        onClose={toggle}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {t("Calculation method for avoided CO2 emissions")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography variant="body2" gutterBottom>
              {t("Avoided CO2")}
            </Typography>
            <p>
              {co2RetrievalText}                
              <br/>
              Source:
              <br/>
              {unitSystem !== 'imperial' && (
                <div>
                  <a
                    href="https://www.rte-france.com/fr/eco2mix/eco2mix-co2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Eco2Mix
                  </a>
                  {" "}{t(
                  "(for France)."
                  )}
                </div>
              )}

              {unitSystem === 'imperial' && (
                <div>
                  <a
                    href="https://www.watttime.org/api-documentation/#obtain-access-token"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Wattime
                  </a>
                  {" "}
                  {t(
                    "(for US)."
                  )}
                </div>
              )}
              <br/>
          </p>
            {CO2Equivalent_co2_for_1km_driven_in_g && 
            <div>
              <Typography variant="body2" gutterBottom>
                {t("Conversion")}
              </Typography>
              <p>
                {distanceConversionText}
                <br/>
                Source:
                <br/>
                {unitSystem !== 'imperial' && (
                  <div>
                    <a
                    href="http://carlabelling.ademe.fr/chiffrescles/r/tauxCo2Europe"
                    target="_blank"
                    rel="noopener noreferrer"
                    >
                    Ademe
                    </a>
                    {" "}
                    {t(
                    "(for France)."
                    )}
                  </div>
                )}
                {unitSystem === 'imperial' && (
                  <div>
                    <a
                      href="https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Environmental Protection Agency
                    </a>
                    {" "}
                    {t(
                      "(for US)."
                    )}
                  </div>
                )}
              </p>
            </div>
            }
            {CO2Equivalent_co2_for_1km_travelled_in_g && CO2Equivalent_world_tour_distance_in_km && 
            <div>
              <Typography variant="body2" gutterBottom>
                {t("World tour conversion")}
              </Typography>
              <p>
                {worldTourConversionText}
                <br/>
                Source:
                <br/>

                {unitSystem !== 'imperial' && (
                  <div>
                  <a
                      href="https://www.consoglobe.com/les-14-modes-de-transport-les-moins-polluants-cg"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ademe
                    </a>
                    {" "}
                    {t(
                      "(for France)."
                    )}
                  </div>
                )}

                {unitSystem === 'imperial' && (//Same as metric, need to be improved with US data
                  <div>
                  <a
                      href="https://www.consoglobe.com/les-14-modes-de-transport-les-moins-polluants-cg"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Ademe
                    </a>
                    {" "}
                    {t(
                      "(for France)."
                    )}
                  </div>
                )}
              </p>
            </div>
            }
            {CO2Equivalent_average_household_electricity_consumption_in_kwh &&
            <div>
              <Typography variant="body2" gutterBottom>
                {t("Homes conversion")}
              </Typography>
              <p>
                {t(
                  `Equivalence in electricity consumption of X homes. To find out the average electricity consumption of a residential home, just divide the total amount of residential electricity consumed (in TWh) by the number of residential homes =` 

                )}
                {" "}
                {CO2Equivalent_average_household_electricity_consumption_in_kwh.co2EquivalentValue}
                {" "}
                {t(`kWh annual electricity consumption per household.`
                )}
                <br/>
                Source:
                <br/>
                {unitSystem !== 'imperial' && (
                  <div>
                    <a
                      href="https://www.edf.fr/groupe-edf/espaces-dedies/l-energie-de-a-a-z/tout-sur-l-energie/le-developpement-durable/l-electricite-dans-le-secteur-residentiel"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      EDF
                    </a>
                    {" "}
                    {t(
                        "(for France)."
                    )}
                  </div>
                )}
                {unitSystem === 'imperial' && (
                  <div>
                    <a
                      href="https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Environmental Protection Agency
                    </a>
                    {" "}
                    {t(
                      "(for US)."
                    )}
                  </div>
                )}
              </p>
            </div>}
            {CO2Equivalent_co2_per_tree_seedings_in_t &&
            <div>
              <Typography variant="body2" gutterBottom>
                {t("Urban Tree Planted")}
              </Typography>
              <p>
                {avoidedCo2PerTreeSeedingsText}
                <br/>
                Source:
                <br/>

                {unitSystem !== 'imperial' && (
                  <div>
                    <a
                      href="https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      EPA
                    </a>
                    {" "}
                    {t(
                        "(for France)."
                    )}
                  </div>
                )}
                {unitSystem === 'imperial' && (
                  <div>
                    <a
                      href="https://www.epa.gov/energy/greenhouse-gases-equivalencies-calculator-calculations-and-references "
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Environmental Protection Agency
                    </a>
                    {" "}
                    {t(
                      "(for US)."
                    )}
                  </div>
                )}
              </p>
            </div>}
            {CO2Equivalent_nuclear_waste_for_1mwh_nuclear_electricity_in_g &&
            <div>
              <Typography variant="body2" gutterBottom>
                {t("Nuclear waste")}
              </Typography>
              <p>
                {nuclearWasteText}
                <br/>
                Source:
                <br/>

                {unitSystem !== 'imperial' && (
                  <div>
                    <a
                      href="http://cpdp.debatpublic.fr/cpdp-dechets-radioactifs/docs/pdf/dossier-initialisation/edf.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      EDF
                    </a>
                    {" "}
                    {t(
                        "(for France)."
                    )}
                  </div>
                )}
                {unitSystem === 'imperial' && (
                  <div>
                    <a
                      href="http://cpdp.debatpublic.fr/cpdp-dechets-radioactifs/docs/pdf/dossier-initialisation/edf.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      EDF
                    </a>
                    {" "}
                    {t(
                        "(for France)."
                    )}
                  </div>
                )}
              </p>
            </div>}
            <Typography variant="body2" gutterBottom>
              {t("Monthly Calculation")}
            </Typography>
            <p>
              {t(
                "Monthly refers to the last month matched"
              )}
            </p>
            <Typography variant="body2" gutterBottom>
              {t("Yearly Calculation")}
            </Typography>
            <p>
              {t(
                "Yearly refers to the year-to-date for the last matching date"
              )}
            </p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={toggle}
            color="primary"
            autoFocus
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EquivalentToCards/AvoidedCO2/AvoidedCO2Dialog.js